export default __webpack_public_path__ + "static/media/plan-intention-reporting.e686b268.md";